<script setup lang="ts">
import type { Popover } from 'primevue';
import { ref } from 'vue';

import type { UserAccountBankDetails } from '@peanuds/shared-state';
import BankDetailsList from './BankDetailsList.vue';

type PrimePopoverInstance = InstanceType<typeof Popover>;

interface Props {
  bankDetails?: UserAccountBankDetails | null;
}

const { bankDetails = null } = defineProps<Props>();

const popoverRef = ref<PrimePopoverInstance | null>(null);
const isPopoverVisible = ref(false);

const toggle = (event: MouseEvent) => {
  const popover = popoverRef.value;
  if (!popover) return;

  if (isPopoverVisible.value) {
    popover.hide();
    isPopoverVisible.value = false;
    return;
  }

  popover.show(event);
  isPopoverVisible.value = true;
};

const hide = () => {
  popoverRef.value?.hide();
  isPopoverVisible.value = false;
};

const isVisible = () => isPopoverVisible.value;

const handleHide = () => {
  isPopoverVisible.value = false;
};

defineExpose({ toggle, hide, isVisible });
</script>

<template>
  <Popover ref="popoverRef" @hide="handleHide" :pt="{ root: { class: 'share-popover' } }">
    <div class="account-details-popover">
      <BankDetailsList :bank-details="bankDetails" />
    </div>
  </Popover>
</template>

<style lang="scss">
.share-popover {
  border-radius: var(--radius-2xl);

  .p-popover-content {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.account-details-popover {
  box-sizing: border-box;
  padding: $static-space-6;
  width: min(f(350, 350), calc(100vw - #{$static-space-6}));
  max-height: calc(100dvh - #{$static-space-12});
  overflow: auto;
}
</style>
